/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ table: NonNullable<unknown>, count: NonNullable<unknown> }} Datasets_Import_Csv_Success_CreatedInputs */



/**
* | output |
* | --- |
* | "Table \"{table}\" created with {count} rows." |
*
* @param {Datasets_Import_Csv_Success_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_success_created = /** @type {((inputs: Datasets_Import_Csv_Success_CreatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_Success_CreatedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tabelle "${i?.table}" mit ${i?.count} Zeilen erstellt.`)
	return /** @type {LocalizedString} */ (`Table "${i?.table}" created with ${i?.count} rows.`)
});